import { useQuery } from '@tanstack/react-query'

import { getPhysiologicalParams } from '@/services/get-physiological-params'

export const PHYSIOLOGICAL_PARAMS_QUERY = 'PHYSIOLOGICAL_PARAMS'

export const useGetPhysiologicalParams = (
  culture: 'soybean' | 'corn' = 'soybean',
) => {
  const query = useQuery({
    queryKey: [PHYSIOLOGICAL_PARAMS_QUERY],
    queryFn: ({ signal }) => getPhysiologicalParams(culture, { signal }),
  })

  return query
}
